<script>
  import { onInterval } from '../clockutil.js';

  var string = 'loading';

  function makeid(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

  function newString() {
    var string = makeid(10);
  }

  onInterval(() => string = makeid(10), 100);

</script>

<style>
  p {
    font-family: monospace;
    position: fixed;
    left: 0;
    bottom: 0;
    margin-left: 5%;
    margin-bottom: 5%;
    z-index: 0;
  }
</style>
<p>{string}</p>
